import React from "react"
import "./Main.css"

const Main = () => {
    return (
        <div class="main">
            <h1 class="main-title">Meet The Truth</h1>
            <p class="main-subtitle">Boosting decentralized discussions through NFT incentives</p>
            <div class="main-images">
                <img src="https://static01.nyt.com/images/2021/03/12/arts/11nft-auction-cryptopunks-print/11nft-auction-cryptopunks-print-mobileMasterAt3x.jpg" />
                <img src="https://www.reuters.com/resizer/KPyPEIt3l_uuN0830xaFD9v2Idc=/1920x2400/smart/filters:quality(80)/cloudfront-us-east-2.images.arcpublishing.com/reuters/34GWN2I7W5LJJDYR7VOOLE7MLY.jpg" />
                <img src="https://miro.medium.com/max/1200/1*5AyYzOlGlv501PlJlIdZZQ.jpeg" />
                <img src="https://lh3.googleusercontent.com/I-9GNJlJwFt13PsqoF2G2r6d0OkvUF1E4k_Wr6IvX31bbVYPAN3-iIn8AFjVu7vvlnrG8ojWP75hg0S4U9SpEKNAm34PwNiQppH4=w600" />
            </div>
        </div>
    )
}

export default Main